import { useState } from 'react';
import BrandService from './BrandService';

function useManageBrands() {
    const [brands, setBrands] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(null);

    const refreshBrands = async (filters = {}) => {
        setIsLoading(true);
        try {
            const response = await BrandService.getBrands(filters);
            const data = response.data.data;
            setBrands(Array.isArray(data) ? data : []);
            setError(null);
        } catch (err) {
            console.log(err);
            setError(err);
        } finally {
            setIsLoading(false);
        }
    };

    const addBrand = async (brandData) => {
        let result = true;
        setIsLoading(true);
        try {
            await BrandService.addBrand(brandData);
            refreshBrands();
        } catch (err) {
            result = false;
            setError(err.response?.data?.message || 'An error occurred.');
        } finally {
            setIsLoading(false);
        }
        return result;
    };

    const editBrand = async (brandId, updatedData) => {
        setIsLoading(true);
        try {
            await BrandService.editBrand(brandId, updatedData);
            refreshBrands();
        } catch (err) {
            setError(err);
        } finally {
            setIsLoading(false);
        }
    };

    const deleteBrand = async (brandId) => {
        setIsLoading(true);
        try {
            await BrandService.deleteBrand(brandId);
            refreshBrands();
        } catch (err) {
            setError(err);
        } finally {
            setIsLoading(false);
        }
    };

    const searchBrand = async (name) => {
        try {
            const response = await BrandService.getBrandByName(name);
            return response.data.data;
        } catch (err) {
            return null;
        }
    };

    return {
        brands,
        isLoading,
        error,
        addBrand,
        editBrand,
        deleteBrand,
        refreshBrands,
        searchBrand
    };
}

export default useManageBrands;
